// extracted by mini-css-extract-plugin
export default {"auth-page__main":"authentication_auth-page__main__OthV6","auth-page__content-container":"authentication_auth-page__content-container__Dq14e"};